import { INote } from "@/models/types/note";
import { create } from "zustand";

export const EmptyNote = {
    _id: '',
    dateMade: new Date(),
    note: '',
    noteName: '',
    relatedId: '',
    relatedName: '',
    relatedType: 'plant',
    userId: '',
    lastEdited: new Date(),
} as INote;

interface ModalStore {
    modalOpen: boolean;
    setModalOpen: (modalOpen: boolean) => void;
    openSignInModal: boolean;
    setOpenSignInModal: (openSignInModal: boolean) => void;
    openSignOutModal: boolean;
    setOpenSignOutModal: (openSignOutModal: boolean) => void;
    openRegisterModal: boolean;
    setOpenRegisterModal: (openRegisterModal: boolean) => void;
    openNewPlantModal: boolean;
    setOpenNewPlantModal: (openNewPlantModal: boolean) => void;
    openNewGrowingPlantModal: boolean;
    setOpenNewGrowingPlantModal: (openNewGrowingPlantModal: boolean) => void;
    openNewNoteModal: boolean;
    setOpenNewNoteModal: (openNewNoteModal: boolean) => void;
};

export const useModalStore = create<ModalStore>((set) => ({
    modalOpen: false,
    setModalOpen: (o) => set({ modalOpen: o }),
    openSignInModal: false,
    setOpenSignInModal: (open) => {
        set({ openSignInModal: open })
    },
    openSignOutModal: false,
    setOpenSignOutModal: (open) => {
        set({ openSignOutModal: open })
    },
    openRegisterModal: false,
    setOpenRegisterModal: (open) => {
        set({ openRegisterModal: open })
    },
    openNewPlantModal: false,
    setOpenNewPlantModal: (o) => {
        set({ openNewPlantModal: o });
    },
    openNewGrowingPlantModal: false,
    setOpenNewGrowingPlantModal: (o) => {
        set({ openNewGrowingPlantModal: o });
    },
    openNewNoteModal: false,
    setOpenNewNoteModal: (o) => {
        set({ openNewNoteModal: o });
    }
}));